import { type Nominal, url } from "./common";

export type LibraryItemId = Nominal<string, "LibraryItem">;

// ---- Entity ----

export type LibraryItem = {
  id: LibraryItemId;
  title: string;
  // Sanity discriminator on content type. The full block-content shape is
  // dynamic (Portable Text); only the discriminator field is statically known.
  content: { __typename: string };
  tags: string[];
  categories: string[];
  imageUrl: string | null;
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  descriptionObj: unknown | null;
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  linkPreviewInfo: unknown | null;
  createdAt: Date;
};

// ---- Models ----

export const libraryModels = {
  LIBRARY_ITEMS: url<LibraryItem[]>(`/library`),
  LIBRARY_ITEM: (id: LibraryItemId) => url<LibraryItem>(`/library/${id}`),
};
